import { createContext, useContext } from 'react'

import _ from 'lodash'

import { RESOURCES } from '@/shared/constants/resources'
import { useUserProgress } from '@/shared/hooks/useUserProgress'

export const ResourceContext = createContext(null)

export const useResourceContext = () => {
  const context = useContext(ResourceContext)
  if (context === undefined) {
    throw new Error('useResourceContext must be used within a ResourceProvider')
  }
  return context
}

export const ResourceProvider = ({
  type,
  id,
  pointsReward = 0,
  coinsReward = 0,
  unlock = {
    journeyId: null,
    missionId: null
  },
  children,
  ...rest
}) => {
  const { userProgress, missionWasFinished, journeyWasFinished } =
    useUserProgress()
  const resource = RESOURCES[type]
  const finishedResources =
    _.get(userProgress, `finished_${resource?.slug?.plural}`, []) || []
  const hasFinished = finishedResources.includes(id)
  const hasRewards = !!pointsReward || !!coinsReward
  let pointsAcquired = hasFinished ? pointsReward : 0
  let coinsAcquired = hasFinished ? coinsReward : 0

  let locked = false
  if (unlock) {
    const { journeyId, missionId } = unlock
    if (journeyId && !journeyWasFinished(journeyId)) locked = true
    if (missionId && !missionWasFinished(missionId)) locked = true
  }

  if (!type) return null
  return (
    <ResourceContext.Provider
      value={{
        type,
        id,

        resource,

        pointsReward,
        coinsReward,
        pointsAcquired,
        coinsAcquired,
        unlock,
        locked,

        hasFinished,
        hasRewards,

        journeyWasFinished,
        missionWasFinished,
        ...rest
      }}
    >
      {children}
    </ResourceContext.Provider>
  )
}
